import Search from "components/SearchBox";
import Box from "@material-ui/core/Box";
import Selector from "components/selector";

const buttonText = {
  Attended: {
    status: "Attended",
    pastButtonText: "Mark as Unattended",
    color: "#26bbed",
  },
  rsvped: {
    status: "RSVPed",
    pastButtonText: "Mark as Attended",
    color: "#66D184",
    upcomingButtonText: "Cancel RSVP",
  },
  canceled: {
    status: "RSVP Canceled",
    pastButtonText: null,
    color: "#F5A623",
    upcomingButtonText: null,
  },
  waitlisted: {
    status: "Waitlisted",
    pastButtonText: null,
    color: "black",
    upcomingButtonText: "Confirm RSVP",
  },
  removed_from_waitlist: {
    status: "Removed From Waitlist",
    pastButtonText: null,
    color: "#E75F75",
    upcomingButtonText: null,
  },
};

const statusFilter = [
  { id: "All", label: "All" },
  { id: "rsvped", label: "RSVPed" },
  { id: "canceled", label: "RSVPed Canceled" },
  { id: "waitlisted", label: "Waitlisted" },
  { id: "removed_from_waitlist", label: "Removed From Waitlist" },
];

const typeFilter = [
  { id: "all", label: "All" },
  { id: "prospect", label: "Prospect" },
  { id: "resident", label: "Resident" },
];

const getColumns = (classes, handleSearch, onStatusFilterChange) => {
  return [
    {
      field: "fullName",
      fieldName: "Invitee",
      sortable: true,
      className: classes.tableHeader,
      cellClassName: classes.tableCell,
      filterable: true,
      filterField: (
        <Box className={classes.searchContainer}>
          <Search
            placeholder="search"
            onSearch={(e) => handleSearch("fullName", e)}
            searchType="auto"
          />
        </Box>
      ),
    },
    {
      field: "isResident",
      fieldName: "Invitee Type",
      sortable: true,
      className: classes.tableHeader,
      cellClassName: classes.tableCell,
      filterable: true,
      filterField: (
        <Box className={classes.searchContainer}>
          <Selector
            value={typeFilter[0]}
            onChange={onStatusFilterChange.bind(this, "isResident")}
            options={typeFilter}
            className={{
              select_root: classes.select_root,
            }}
          />
        </Box>
      ),
    },
    {
      field: "email",
      fieldName: "Email",
      sortable: true,
      className: classes.tableHeader,
      cellClassName: classes.tableCell,
      filterable: true,
      filterField: (
        <Box className={classes.searchContainer}>
          <Search
            placeholder="search"
            onSearch={(e) => handleSearch("email", e)}
            searchType="auto"
          />
        </Box>
      ),
    },
    {
      field: "phone",
      fieldName: "Phone Number",
      sortable: true,
      className: classes.tableHeader,
      cellClassName: classes.tableCell,
      filterable: true,
      filterField: (
        <Box className={classes.searchContainer}>
          <Search
            placeholder="search"
            onSearch={(e) => handleSearch("phone", e)}
            searchType="auto"
          />
        </Box>
      ),
    },
    {
      field: "additionalGuests",
      fieldName: "Add’l Guests",
      sortable: true,
      className: classes.tableHeader,
      cellClassName: classes.tableCell,
      filterable: true,
      filterField: (
        <Box className={classes.searchContainer}>
          <Search
            placeholder="search"
            onSearch={(e) => handleSearch("additionalGuests", e)}
            searchType="auto"
          />
        </Box>
      ),
    },
    {
      field: "status",
      fieldName: "Status",
      sortable: true,
      className: classes.tableHeader,
      cellClassName: classes.tableCell,
      filterable: true,
      filterField: (
        <Box className={classes.searchContainer}>
          <Selector
            value={statusFilter[0]}
            onChange={onStatusFilterChange.bind(this, "status")}
            options={statusFilter}
            className={{
              select_root: classes.select_root,
            }}
          />
        </Box>
      ),
    },
    {
      field: "action",
      fieldName: "",
      className: classes.tableHeader,
      cellClassName: classes.tableCell,
      align: "right",
    },
  ];
};

export { buttonText, getColumns };
